
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as emailZPju4AMtdqGBMPTDLw3nseoqvQVPGg6eqk6EKLqBIPMMeta } from "/home/archerist/nuxt3_ogrenci/pages/email.vue?macro=true";
import { default as index1TRE97cdsQJ5KVGBLc0q2MKv_TjuLGsM7k_45mN_uSWQAMeta } from "/home/archerist/nuxt3_ogrenci/pages/index.vue?macro=true";
import { default as indexhg3SORhWH8QQFnCcsKzoVEV6wmhz_45MrCe0ttLsYcgLQMeta } from "/home/archerist/nuxt3_ogrenci/pages/archive/index.vue?macro=true";
import { default as indexM72XehiBQD_45nyDIWmWgDyQY8oRpbgMn_KABGNCX9a_EMeta } from "/home/archerist/nuxt3_ogrenci/pages/reports/index.vue?macro=true";
import { default as citiesBdbxT3gy0v51CF6hrCxYh2EVZxSHNm8OA9ra7EMabxYMeta } from "/home/archerist/nuxt3_ogrenci/pages/reports/cities.vue?macro=true";
import { default as indexuFDDVtvLkBfmo0j04khMAvlUXKygWvoCJINxwzKoLwcMeta } from "/home/archerist/nuxt3_ogrenci/pages/settings/index.vue?macro=true";
import { default as indexqPZuUle4xHXt1YcSZvyGM9XnH8iu4MudQMA_45vetOdQgMeta } from "/home/archerist/nuxt3_ogrenci/pages/students/index.vue?macro=true";
import { default as forcepasschangegdrSuseWCI5nb8Vuwu6gua8CHBx66q9lA8VTu8GNsOkMeta } from "/home/archerist/nuxt3_ogrenci/pages/forcepasschange.vue?macro=true";
import { default as cancelsesIdEhdsvOav8lUhru_RkKzuTEZZndv5EouIVmP8yYUMeta } from "/home/archerist/nuxt3_ogrenci/pages/reports/cancels.vue?macro=true";
import { default as fakulte4ObBE8dE9dqNiyjYty34kof9nrFNY5pbC6rQ8bxz6DIMeta } from "/home/archerist/nuxt3_ogrenci/pages/reports/fakulte.vue?macro=true";
import { default as periodic6bLMmHJy4nCMhnjyOkILh50ZuB_bGLGy93N6plmnOQoMeta } from "/home/archerist/nuxt3_ogrenci/pages/reports/periodic.vue?macro=true";
import { default as daterangeSCHc4VblQL_45v5N63xVoihVieT9LN2TGDWbZj1vKyhK0Meta } from "/home/archerist/nuxt3_ogrenci/pages/reports/daterange.vue?macro=true";
import { default as graduatesoGDKACQFR4GgiDEQFJJ6au3gHHHzLwZcMlocUHTD8H0Meta } from "/home/archerist/nuxt3_ogrenci/pages/reports/graduates.vue?macro=true";
import { default as newmembersUIlqfdDqVKvu_rpkyI4OrAC8jlqFZStSih7m7giEsEYMeta } from "/home/archerist/nuxt3_ogrenci/pages/reports/newmembers.vue?macro=true";
import { default as universitiesqWdQQvDoYqFN0Y8OicoKXwbriuPlrhnycq4_45_mYXQEUMeta } from "/home/archerist/nuxt3_ogrenci/pages/reports/universities.vue?macro=true";
import { default as ogrenciseviyenINeOP2n8Mh3oMcSUcHlUojKTIVmyi0lR8RI9k_457YuoMeta } from "/home/archerist/nuxt3_ogrenci/pages/reports/ogrenciseviye.vue?macro=true";
import { default as idBIGwSxitfUw5cRVRYY6s1g9F9mZuckTyr8dPJscaLIcMeta } from "/home/archerist/nuxt3_ogrenci/pages/students/[username]/id.vue?macro=true";
import { default as legalWUkEH1DN5eC_1IHahLTa9d_45C6RhfGg8gSyKkRv1r9tgMeta } from "/home/archerist/nuxt3_ogrenci/pages/students/[username]/legal.vue?macro=true";
import { default as emailsonSEBxkUDZmG37nRb3Q6WtQopXrhAuK9sXNvaiimss0Meta } from "/home/archerist/nuxt3_ogrenci/pages/students/[username]/emails.vue?macro=true";
import { default as familyRq_45hr_45lJQOwoYH_UrF8uTWduUpoRV4MalgNmTb3m5vwMeta } from "/home/archerist/nuxt3_ogrenci/pages/students/[username]/family.vue?macro=true";
import { default as schooljZVAcQdrp9OGKFLz_ww1UCiO87YQmRAwoOafUlv0HrMMeta } from "/home/archerist/nuxt3_ogrenci/pages/students/[username]/school.vue?macro=true";
import { default as paymentsadhxyrLyu1nCt6i_JQ9MmPotPhEfqwmz9X5Buw0XpdYMeta } from "/home/archerist/nuxt3_ogrenci/pages/students/[username]/payments.vue?macro=true";
import { default as settingss6ARpnl6HQnmc9FiqGdVd3AvJcwWTAkU_45Z_EugnWsOIMeta } from "/home/archerist/nuxt3_ogrenci/pages/students/[username]/settings.vue?macro=true";
export default [
  {
    name: "email",
    path: "/email",
    component: () => import("/home/archerist/nuxt3_ogrenci/pages/email.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index1TRE97cdsQJ5KVGBLc0q2MKv_TjuLGsM7k_45mN_uSWQAMeta || {},
    component: () => import("/home/archerist/nuxt3_ogrenci/pages/index.vue")
  },
  {
    name: "archive",
    path: "/archive",
    component: () => import("/home/archerist/nuxt3_ogrenci/pages/archive/index.vue")
  },
  {
    name: "reports",
    path: "/reports",
    component: () => import("/home/archerist/nuxt3_ogrenci/pages/reports/index.vue")
  },
  {
    name: "reports-cities",
    path: "/reports/cities",
    component: () => import("/home/archerist/nuxt3_ogrenci/pages/reports/cities.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/home/archerist/nuxt3_ogrenci/pages/settings/index.vue")
  },
  {
    name: "students",
    path: "/students",
    component: () => import("/home/archerist/nuxt3_ogrenci/pages/students/index.vue")
  },
  {
    name: "forcepasschange",
    path: "/forcepasschange",
    meta: forcepasschangegdrSuseWCI5nb8Vuwu6gua8CHBx66q9lA8VTu8GNsOkMeta || {},
    component: () => import("/home/archerist/nuxt3_ogrenci/pages/forcepasschange.vue")
  },
  {
    name: "reports-cancels",
    path: "/reports/cancels",
    component: () => import("/home/archerist/nuxt3_ogrenci/pages/reports/cancels.vue")
  },
  {
    name: "reports-fakulte",
    path: "/reports/fakulte",
    component: () => import("/home/archerist/nuxt3_ogrenci/pages/reports/fakulte.vue")
  },
  {
    name: "reports-periodic",
    path: "/reports/periodic",
    component: () => import("/home/archerist/nuxt3_ogrenci/pages/reports/periodic.vue")
  },
  {
    name: "reports-daterange",
    path: "/reports/daterange",
    component: () => import("/home/archerist/nuxt3_ogrenci/pages/reports/daterange.vue")
  },
  {
    name: "reports-graduates",
    path: "/reports/graduates",
    component: () => import("/home/archerist/nuxt3_ogrenci/pages/reports/graduates.vue")
  },
  {
    name: "reports-newmembers",
    path: "/reports/newmembers",
    component: () => import("/home/archerist/nuxt3_ogrenci/pages/reports/newmembers.vue")
  },
  {
    name: "reports-universities",
    path: "/reports/universities",
    component: () => import("/home/archerist/nuxt3_ogrenci/pages/reports/universities.vue")
  },
  {
    name: "reports-ogrenciseviye",
    path: "/reports/ogrenciseviye",
    component: () => import("/home/archerist/nuxt3_ogrenci/pages/reports/ogrenciseviye.vue")
  },
  {
    name: "students-username-id",
    path: "/students/:username()/id",
    component: () => import("/home/archerist/nuxt3_ogrenci/pages/students/[username]/id.vue")
  },
  {
    name: "students-username-legal",
    path: "/students/:username()/legal",
    component: () => import("/home/archerist/nuxt3_ogrenci/pages/students/[username]/legal.vue")
  },
  {
    name: "students-username-emails",
    path: "/students/:username()/emails",
    component: () => import("/home/archerist/nuxt3_ogrenci/pages/students/[username]/emails.vue")
  },
  {
    name: "students-username-family",
    path: "/students/:username()/family",
    component: () => import("/home/archerist/nuxt3_ogrenci/pages/students/[username]/family.vue")
  },
  {
    name: "students-username-school",
    path: "/students/:username()/school",
    component: () => import("/home/archerist/nuxt3_ogrenci/pages/students/[username]/school.vue")
  },
  {
    name: "students-username-payments",
    path: "/students/:username()/payments",
    component: () => import("/home/archerist/nuxt3_ogrenci/pages/students/[username]/payments.vue")
  },
  {
    name: "students-username-settings",
    path: "/students/:username()/settings",
    component: () => import("/home/archerist/nuxt3_ogrenci/pages/students/[username]/settings.vue")
  }
]